var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',{staticClass:"record-info-grid"},_vm._l((_vm.fields),function(field){return _c('div',{key:field.label,class:{ 'info-wide': field.wide }},[_c('dt',[_vm._v(_vm._s(field.label))]),_c('dd',{class:{ 'info-ltr': field.ltr }},[_c('span',[_vm._v(_vm._s(_vm.value(field.value)))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }